import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {stringToNumberInRange} from '../../util/stringHelper'
import './Assignee.scss'

export const assigneeColors = [
  'assignee--color-0',
  'assignee--color-1',
  'assignee--color-2',
  'assignee--color-3',
  'assignee--color-4',
  'assignee--color-5',
  'assignee--color-6',
  'assignee--color-7',
  'assignee--color-8',
  'assignee--color-9',
  'assignee--color-10',
  'assignee--color-11',
  'assignee--color-12',
  'assignee--color-13',
  'assignee--color-14',
  'assignee--color-15',
  'assignee--color-16',
  'assignee--color-17',
  'assignee--color-18',
  'assignee--color-19'
]

export const getFullNameForAssignee = (assignment) => {
  return [ assignment.firstName, assignment.lastName ]
    .filter(name => name)
    .join(' ')
}

export const toUser = (assignment) => ({
  id: assignment.userId,
  firstName: assignment.firstName,
  lastName: assignment.lastName
})

export const fromUser = (user) => ({
  userId: user.id,
  firstName: user.firstName,
  lastName: user.lastName
})

const firstCharacter = (string) => string ? string[0] : ''

const getInitialsForAssignee = (assignment) =>
  firstCharacter(assignment.firstName) + firstCharacter(assignment.lastName)

export const getAssignmentColor = (userId) => {
  const colorIndex = stringToNumberInRange(userId, 0, assigneeColors.length)

  return assigneeColors[colorIndex]
}

const Assignee = props => {
  const assigneeColorClass = getAssignmentColor(props.assignment.userId)
  const assigneeClassNames = classNames({
    assignee: true,
    [assigneeColorClass]: true
  })

  return (
    <div
      onClick={props.onClick}
      className={assigneeClassNames}
      title={getFullNameForAssignee(props.assignment)}>
      {getInitialsForAssignee(props.assignment)}
    </div>
  )
}

Assignee.propTypes = {
  onClick: PropTypes.func,
  assignment: PropTypes.object.isRequired
}

export default Assignee



// WEBPACK FOOTER //
// ./src/components/Assignee/Assignee.js